(function() {
    angular.module('GorillaBoy.services')
    .factory('InviteService', ['$http', 'EndpointService', 'AppConstants',
        function($http, EndpointService, AppConstants) {

        // AppConstant bindings
        var httpMethods = AppConstants.HttpMethods;

        var inviteService = {};

        inviteService.inviteUsers = function(emails, subject, message, resend) {
            var config = {
                url: EndpointService.endpoint() + 'invite/',
                method: httpMethods.POST,
                data: {
                    Emails: emails
                }
            };
            if (subject && subject.length > 0) {
                config.data.Subject = subject;
            }
            if (message && message.length > 0) {
                config.data.Message = message;
            }
            if (resend) {
                config.data.ResendInvites = resend;
            }
            return $http(EndpointService.tokenize(config));
        };

        return inviteService;
    }]);
}());
